import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppRoutes from './routes';
import { AuthProvider } from './context/AuthContext';
import { ToastHost } from './components/ui/SharedLayout';

const App = () => {
  return (
    <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AppRoutes />
        <ToastContainer position="top-right" autoClose={5000} />
        <ToastHost />
      </Router>
    </AuthProvider>
  );
};

export default App;
